import React from 'react'
import AmazonBooks from './AmazonBooks'
import DigitalTwinBanner from './DigitalTwinBanner'
import IndustrialEnvironments from './IndustrialEnvironments'
import RoomBuilding from './RoomBuilding'
import VirtualWorlds from './VirtualWorlds'
import HomeOffice from './HomeOffice'
import Winery from './Winery'
import HomeOfficeBanner from './HomeOfficeBanner'
import UniversityCampus from './UniversityCampus'
import Photogrammetry from './Photogrammetry'

const DigitalTwin = () => {
    document.title = "Paracosma | Digital Twins"
    return (
        <>
			<div className="main-body">
                <DigitalTwinBanner />
                <AmazonBooks />
                <VirtualWorlds />
                <IndustrialEnvironments />
                <Winery />
                <RoomBuilding />
                <HomeOfficeBanner />
				<HomeOffice />
                <UniversityCampus />
                <Photogrammetry />
			</div>
          
        </>
    )
}

export default DigitalTwin
